var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailFavourite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "communication/outline/mail_favourite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 13.5L8.7 15.15C9.76667 15.95 11.2333 15.95 12.3 15.15L14.5 13.5M18.7191 7.52391L16.865 5.20626C16.6287 4.91091 16.5 4.54394 16.5 4.1657V4.09099C16.5 3.21231 17.2123 2.5 18.091 2.5C18.5129 2.5 18.9176 2.66762 19.216 2.96599L19.5 3.25L19.784 2.96599C20.0824 2.66762 20.4871 2.5 20.909 2.5C21.7877 2.5 22.5 3.21231 22.5 4.09099V4.1657C22.5 4.54394 22.3713 4.91091 22.135 5.20626L20.2809 7.52391C19.8805 8.02432 19.1195 8.02432 18.7191 7.52391ZM5.5 22.5H15.5C17.1569 22.5 18.5 21.1569 18.5 19.5V11.5C18.5 9.84315 17.1569 8.5 15.5 8.5H5.5C3.84315 8.5 2.5 9.84315 2.5 11.5V19.5C2.5 21.1569 3.84315 22.5 5.5 22.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailFavourite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail_favourite.3d397027348a5c6609cb9b9af78b602b.svg";